import React, { useEffect, useState } from "react";
import { AppBar, Card, MenuItem, Select, Tab, Tabs } from "@mui/material";
import HotelSelector from "components/HotelSelector";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { FaPlaneArrival, FaPlaneDeparture, FaPlus } from "react-icons/fa";
import ArrivalsTable from "./components/ArrivalsTbale";
import DeparturesTable from "./components/DeaprturesTable";
import DateRangeFilter from "components/DateRangePicker";
import CalendarStatsButton from "./components/CalenderStats";
import VuiTooltip from "components/VuiTooltip";
import useCommon from "hooks/useCommon";

const Arrivals = () => {
  const { SEARCH_PARAMS } = useCommon();

  const [type, setType] = useState(SEARCH_PARAMS.get("tab") || "arrivals");
  const [dateRange, setDateRange] = useState(["", ""]);
  const [search, setSearch] = useState("");
  const [range, setRange] = useState("today");
  const [tab, setTab] = useState(0);

  const handleTabChange = (_, newValue) => {
    setType(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox>
        <VuiBox py={1}>
          <VuiBox mb={2}>
            <Card sx={{ p: 2 }}>
              {/* DESKTOP VIEW  */}
              <VuiBox
                display={{ xs: "none", md: "flex" }}
                mb="15px"
                alignItems="center"
                justifyContent="space-between"
                gap={2}
              >
                <VuiBox>
                  <VuiTypography
                    variant="lg"
                    sx={{
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    Arrivals & Departures
                  </VuiTypography>
                </VuiBox>

                <VuiBox display="flex" gap={1.5} alignItems="center">
                  <CalendarStatsButton setRange={setRange} setDateRange={setDateRange} />

                  {range === "all" && <DateRangeFilter value={dateRange} onChange={setDateRange} />}

                  <HotelSelector minWidth={200} />

                  <VuiBox sx={{ width: { xs: "150px" } }}>
                    <VuiInput
                      gradient
                      fullWidth
                      placeholder="Search guests..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </VuiBox>
                </VuiBox>
              </VuiBox>

              {/* MOBILE VIEW */}
              <VuiBox
                display={{ xs: "flex", md: "none" }}
                mb="22px"
                flexDirection="column"
                gap={1.5}
              >
                {/* Row 1 — Hotel + Calendar */}
                <VuiBox display="flex" gap={1.5} alignItems="center">
                  <VuiBox flex={1}>
                    <HotelSelector fullWidth minWidth={170} />
                  </VuiBox>

                  <VuiBox sx={{ dispaly: { xs: "none", md: "flex" } }}>
                    <CalendarStatsButton setRange={setRange} setDateRange={setDateRange} />
                  </VuiBox>
                </VuiBox>

                {/* Row 2 — Search + Date Range */}
                <VuiBox display="flex" gap={1.5} alignItems="center">
                  <VuiBox flex={1}>
                    <VuiInput
                      gradient
                      fullWidth
                      placeholder="Search guests..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </VuiBox>

                  {range === "all" && (
                    <VuiBox
                      sx={{
                        maxWidth: 170,
                        flexShrink: 0,
                      }}
                    >
                      <DateRangeFilter
                        value={dateRange}
                        onChange={setDateRange}
                        sx={{
                          "& .MuiInputBase-input": {
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          },
                        }}
                      />
                    </VuiBox>
                  )}
                </VuiBox>
              </VuiBox>

              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <AppBar position="static" color="transparent" elevation={0}>
                  <Tabs
                    value={type}
                    variant="fullWidth"
                    onChange={handleTabChange}
                    sx={{
                      background: "transparent",
                      display: "flex",
                      justifyContent: "flex-end",

                      "& .MuiTab-root": {
                        minWidth: { xs: "auto", md: 350 },
                        px: { xs: 2, sm: 3 },
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <Tab
                      value="arrivals"
                      label="Arrivals"
                      icon={<FaPlaneArrival size={14} />}
                      iconPosition="start"
                    />
                    <Tab
                      value="departures"
                      label="Departures"
                      icon={<FaPlaneDeparture size={14} />}
                      iconPosition="start"
                    />
                  </Tabs>
                </AppBar>
                <VuiBox mt={1}>
                  {type === "arrivals" && (
                    <ArrivalsTable
                      range={range}
                      setRange={setRange}
                      search={search}
                      dateRange={dateRange}
                    />
                  )}
                  {type === "departures" && (
                    <DeparturesTable
                      range={range}
                      setRange={setRange}
                      search={search}
                      dateRange={dateRange}
                    />
                  )}
                </VuiBox>
              </VuiBox>
            </Card>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </DashboardLayout>
  );
};

export default Arrivals;
